import React, { Component } from 'react';
import Modal from "../UI/Modal/Modal";
import FormatModal from "../UI/FormatModal/FormatModal";
import "./PopupModal.css"
import ExitModalDesktop from "../images/ExitModalDesktop.png"
import ExitModalMobile from "../images/ExitModalMobile.png"
import Form from "../components/Form"
class Banner extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }


    render() {
        let { isModal, idlePopupData } = this.props
        return (
            <Modal toggle={this.props.handleModalBtn} hidden={!isModal} >
                <FormatModal>
                    <div className="ExitPopupModal">
                        <div className="ExitPopupModal-col1">
                            <div className="DesktopImage"><img src={idlePopupData ? idlePopupData.DesktopImg : ExitModalDesktop} alt="" /></div>
                            <div className="MobileImage"><img src={idlePopupData ? idlePopupData.MobileImg : ExitModalMobile} alt="" /></div>
                        </div>
                        <div className="ExitPopupModal-col2">
                            <div className="ExitPopupModal-col2-TextContent">
                                <div className="ExitPopupModal-col2-TextHeading">
                                    {idlePopupData ? `${idlePopupData.Heading}` : `Leaving so soon? 70,00,000+ students are waiting for you!`}
                                </div>
                                <div className="ExitPopupModal-col2-TextSubHeading">
                                    {idlePopupData ? `${idlePopupData.SubHeading}` : `Schedule a free demo, and let us help you become one of the most renowned teachers in the country with your app!`}
                                </div>
                                <div className="ExitPopupModalForm">
                                    <Form />
                                </div>
                            </div>
                        </div>
                    </div>
                </FormatModal>
            </Modal>
        );
    }
}

export default Banner;
